import { createContext, useContext, useState } from "react";

const FullscreenContext = createContext({
  isFullscreen: false,
  setIsFullscreen: () => {},
});

export const useFullscreen = () => {
  const context = useContext(FullscreenContext);

  if (!context) {
    console.warn("useFullscreen must be used within FullscreenProvider");
    return {
      isFullscreen: false,
      setIsFullscreen: () => {},
    };
  }
  return context;
};

export const FullscreenProvider = ({ children }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <FullscreenContext.Provider value={{ isFullscreen, setIsFullscreen }}>
      {children}
    </FullscreenContext.Provider>
  );
};
